import { createScreenStyles } from '../../theme/styles';
import { OPERATIONS_API_BASE } from '../../config/api';
import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  Text,
  StyleSheet,
  TextInput,
  Image,
  TouchableHighlight,
  Dimensions,
  Platform 
} from "react-native";
import RadioForm, {
  RadioButton,
  RadioButtonInput,
  RadioButtonLabel,
} from "react-native-simple-radio-button";
import { Ionicons } from '@expo/vector-icons';

const screenWidth = Math.round(Dimensions.get("window").width);
const screenHeight = Math.round(Dimensions.get("window").height);

export function isIphoneX() {
  return Platform.OS === "ios" && screenHeight >= 812;
}

export function isAndroid() {
  return Platform.OS !== "ios";
}

export default function avaliar({ route, navigation }) {
  const { nomeitem, iditem, fab, status, statusExit, mod, type } = route.params;
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState("");
  const [avaliacao, setAvaliacao] = useState(null);
  const [foto, setFoto] = useState(null);
  const [fotoSeq, setFotoSeq] = useState(null);

  var radio_props = [
    { label: "Bom", value: 0 },
    { label: "Ruim", value: 1 },
    { label: "Faltante", value: 2 },
  ];

  async function load() {
    let response;
    if(type === 0){
      response = await fetch(
        `${OPERATIONS_API_BASE}/checklistcompitem/` + iditem
      );
    } else {
      response = await fetch(
        `${OPERATIONS_API_BASE}/checklistcompitemexit/` + iditem
      );
    }

    const data = await response.json();
    setAvaliacao(data[0].avaliacao);
    setComments(data[0].comentario);
    setFoto(data[0].foto);
    if(data[0].fotoSeq === null) {
      setFotoSeq(1);
    } else {
      setFotoSeq(data[0].fotoSeq);
    }
  }

  async function save() {
    let sUrl = type === 0 ? `${OPERATIONS_API_BASE}/checklistcompitem/` : `${OPERATIONS_API_BASE}/checklistcompitemexit/`
    const responseApi = await fetch(
      sUrl + iditem,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          avaliacao: avaliacao,
          comentario: comments,
        }),
      }
    );

    const data = await responseApi.json();

    if (responseApi.ok) {
      route.params.refresh();
      navigation.goBack(null);
    } else {
      alert("error " + data);
    }
  };

  async function removeImg() {
    let sUrl = type === 0 ? `${OPERATIONS_API_BASE}/checklistcompitem/` : `${OPERATIONS_API_BASE}/checklistcompitemexit/`;
    const responseApi = await fetch(
      sUrl + iditem,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          foto: null,
          fotoSeq: fotoSeq + 1
        }),
      }
    );

    const data = await responseApi.json();

    if (responseApi.ok) {
      //setLoading(true);
      load();
      //setLoading(false);
    } else {
      alert("error " + data);
    }
  }

  useEffect(() => {
    //setLoading(true);
    load();
    //setLoading(false);
  }, []);

  return (
    <ScrollView style={styles.containerGeral}>
      <View style={styles.txtContainer}>
        <Text style={styles.textDescBold2}>{nomeitem}</Text>
        <Text numberOfLines={1} style={styles.textDesc}>
          <Text style={styles.textDescBold}>Fabricante: </Text>
          {fab}
        </Text>
        <Text numberOfLines={1} style={styles.textDesc}>
          <Text style={styles.textDescBold}>Modelo: </Text>
          {mod}
        </Text>

        <View style={{ marginTop: 20 }}>
          <RadioForm formHorizontal={true} animation={true}>

            {radio_props.map((obj, i) => (
              <RadioButton labelHorizontal={false} key={i}>
                
                <RadioButtonLabel
                  obj={obj}
                  index={i}
                  disabled={(type === 0 && status > 0) || (type === 1 && statusExit > 0)}
                  labelHorizontal={true}
                  onPress={(value) => {
                    setAvaliacao(value);
                  }}
                  labelStyle={{
                    fontSize: 16,
                    color: "#484848",
                    marginLeft: 35,
                  }}
                  labelWrapStyle={{}}
                />
                <RadioButtonInput
                  obj={obj}
                  index={i}
                  isSelected={avaliacao === i}
                  onPress={(value) => {
                    setAvaliacao(value);
                  }}
                  disabled={(type === 0 && status > 0) || (type === 1 && statusExit > 0)}
                  borderWidth={1}
                  buttonInnerColor={"#003c84"}
                  buttonOuterColor={avaliacao === 0 ? "#484848" : "#484848"}
                  buttonSize={15}
                  buttonOuterSize={25}
                  buttonStyle={{ padding: 0 }}
                  buttonWrapStyle={{ marginLeft: 40, marginTop: 5 }}
                />
              </RadioButton>
            ))}
          </RadioForm>
        </View>
      </View>

      <TextInput
        style={styles.textSearch}
        placeholder={status < 1 ? "Digite suas observações": ""}
        placeholderTextColor="#484848"
        maxLength={200}
        editable={(type === 0 && status < 1) || (type === 1 && statusExit < 1)}
        multiline={true}
        autoCapitalize="sentences"
        value={comments}
        onChangeText={setComments}
      />

      {((type === 0 && status < 1) || (type === 1 && statusExit < 1)) &&
        <View style={styles.sideContainer}>
          <TouchableHighlight style={{ flex: 1, minWidth: 0 }}
            underlayColor={"transparent"}
            onPress={async () => {
              let sUrl = type === 0 ? `${OPERATIONS_API_BASE}/checklistcompitem/` : `${OPERATIONS_API_BASE}/checklistcompitemexit/`;
              const responseApi = await fetch(
                sUrl + iditem,
                {
                  method: "PUT",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    avaliacao: avaliacao,
                    comentario: comments,
                  }),
                }
              );
              navigation.navigate("Camera", { iditem: iditem, fotoSeq: fotoSeq, tipo: 'comp', typeComp: type ,refresh: load });
            }}
          >
            <View style={styles.menuItem}>
              {foto && 
                <Text style={styles.textMenu}>Alterar Foto</Text>
              }
              {!foto && 
                <Text style={styles.textMenu}>Adicionar Foto</Text>
              }
            </View>
          </TouchableHighlight>

          <TouchableHighlight style={{ flex: 1, minWidth: 0 }}
            underlayColor={"transparent"}
            onPress={() => {
              save();
            }}
          >
            <View style={styles.menuItem}>
              <Text style={styles.textMenu}>Salvar</Text>
            </View>
          </TouchableHighlight>
        </View>
    }

    {foto &&
      <View style={styles.sideContainer2}>
        <Text>Foto atual:</Text>
        <Image style={styles.tinyLogo} source={{ uri: foto }} />
        {status < 1 &&
          <TouchableHighlight
              underlayColor={"transparent"}
              style={{ position: 'absolute', top: 30, left: 10 }}
              onPress={() => {
                removeImg();
              }}
            >
            <Ionicons name="close" color="#900603" size={25}  />
          </TouchableHighlight>
        }
      </View>
    }
    </ScrollView>
  );
}

var styles = createScreenStyles({
  container: {
    flex: 1,
    backgroundColor: "#e5e5e5",
  },

  LoadingIndicator: {
    flex: 1,
    justifyContent: "center",
    marginTop: 15,
  },

  sideContainer: {
    flexDirection: "row", gap: 12,
  },

  tinyLogo: {
    height: 180,
    width: 150,
    borderRadius:10
  },

  sideContainer2: {
    marginTop: 20,
  },

  ItemImg: {
    backgroundColor: "#fff",
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 4,
    marginLeft: screenWidth * 0.025,
    marginRight: screenWidth * 0.025,
  },

  menuItem: {
    width: '100%',
    height: screenHeight * 0.1,
    marginTop: 10,
    marginRight: 0,
    backgroundColor: "#296D98",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemG: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "green",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemY: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "#CC6600",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemR: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "red",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  textMenu: {
    color: "#fff",
    fontSize: 16,
  },

  textSearch: {
    width: '94%',
    paddingLeft: 10,
    color: "#484848",
    height: 100,
    marginTop: screenHeight * 0.03,
    backgroundColor: "#fff",
    borderColor: "#A1A1A1",
    borderWidth: 1,
    borderRadius: 5,
  },

  textEmpty: {
    fontSize: 14,
    fontWeight: "300",
    color: "#484848",
    marginLeft: screenWidth * 0.025,
    marginTop: 10,
    textAlign: "center",
  },

  textDesc: {
    fontSize: 14,
    paddingTop: 5,
  },

  textDescBold: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
  },

  textDescBold2: {
    fontSize: 16,
    marginBottom: 10,
    marginTop: 10,
    fontWeight: "bold",
    textAlign: "center",
  },

  textDescAberto: {
    fontSize: 12,
    paddingTop: 5,
    color: "green",
  },

  containerGeral: {
    flex: 1,
    backgroundColor: "#fff",
    paddingLeft: 10,
    paddingBottom: 10,
    borderRadius: 3,
  },

  txtContainer: {
    width: '95%',
    marginTop: 5,
  },

  highlight: {
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
  },

  buttonDone: {
    backgroundColor: "#336633",
    marginTop: 5,
    height: 30,
    width: '90%',
    justifyContent: "center",
  },

  buttonPend: {
    backgroundColor: "#993333",
    marginTop: 5,
    height: 30,
    width: '90%',
    justifyContent: "center",
  },

  buttonText: {
    textAlign: "center",
    color: "#fff",
  },
});
